/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('global/Geolocation',[
    'jquery',
    './Logger'
], function ($, Logger) {
    'use strict';

    function isGeolocationSupported() {
        return !!navigator.geolocation;
    }

    function getPosition(options) {
        var $deferred;
        if (isGeolocationSupported()) {
            $deferred = $.Deferred();
            navigator.geolocation.getCurrentPosition($deferred.resolve, $deferred.reject, options);
        } else {
            $deferred = $.Deferred().reject('Not supported');
        }
        return $deferred.promise();
    }

    var Geolocation = {
        getPosition: getPosition
    };

    Logger.debug('Geolocation.js Loaded:', Geolocation);

    return Geolocation;

});
